import clsx from "clsx";
import type { WindowLabel } from "@/lib/types";

interface Props {
  value: WindowLabel;
  onChange: (w: WindowLabel) => void;
}

const OPTIONS: WindowLabel[] = ["24h", "7d", "30d"];

export function WindowToggle({ value, onChange }: Props) {
  return (
    <div className="inline-flex rounded border border-border bg-panel/60 p-0.5 text-[11px] font-mono">
      {OPTIONS.map((w) => (
        <button
          key={w}
          onClick={() => onChange(w)}
          className={clsx(
            "px-3 py-1 uppercase tracking-wider transition-all",
            value === w
              ? "bg-accent/20 text-accent neon-text shadow-glow"
              : "text-muted hover:text-accent2"
          )}
        >
          {w}
        </button>
      ))}
    </div>
  );
}
